export type QueryParam = Record<
  string,
  string | number | boolean | string[] | number[]
>;
export class URLParams {
  constructor(private queryParams: QueryParam) {}

  toString(): string {
    return Object.entries(this.queryParams)
      .map(([key, value]) => {
        if (Array.isArray(value)) {
          return value
            .map((item) => `${key}[]=${encodeURIComponent(item)}`)
            .join('&');
        } else {
          return `${key}=${encodeURIComponent(value)}`;
        }
      })
      .join('&');
  }
}
